module.exports = __webpack_public_path__ + "static/the-workroom-55c8432454f5d0d5199a9b6955d4b34f.mp4";